import validate from './validate.js'
const TIMESTAMP_UNITS = { '年': 31557600000, '月': 2629800000, '天': 86400000, '小时': 3600000, '分钟': 60000, '秒': 1000 }

function humanize(milliseconds) {
  let humanize = ''

  for (let key in this.UNITS) {
    if (milliseconds >= this.UNITS[key]) {
      humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前'
      break
    }
  }

  return humanize || '刚刚'
}

export default {
  /**
	 * 获取随机 Key
	 * @returns {string}
	 */
	getRandomKey(prefix = '') {
		return prefix + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
  },

  /**
	 * 转换为十位数
	 * @params {number|string} number
	 * @returnss {string}
	 */
  parseTens(number) {
    return (number < 10 ? ('0' + number) : number)
  },

  /**
	 * 删除前后空格
	 * @params {number|string}
	 * @returns {string}
	 */
  formatTextInterval(text) {
    if (!text) return text

    let originText = `${text}`
    return originText.replace(/^\s*|\s*$/g, '')
  },

  /**
   * 格式化文本
   * @param {string} text 分割文本
   * @param {number} num 分割位置
   * @return {string}
   *
   * qs: 400440044004 => 4004 4004 40004
   */
  formatText(text, num = 4) {
    if (!text) return text

    let originText = `${text}`

    let targetText = ''

    for (var i = 0, l = originText.length; i < l / num; i++) {
      let section = originText.slice(num * i, num * (i + 1))
      targetText += `${section} `
    }

    return targetText
  },

  /**
   * 格式化手机号
   * @param {string|number} num
   * @return {string}
   */
  formatPhone(num) {
    let str = num.toString().replace(/ /g, '')
    let len = str.length
    switch (true) {
      case len > 11:
        return str.substr(0, 3) + ' ' + str.substr(3, 4) + ' ' + str.substr(7, 4)
      case len > 7:
        return str.substr(0, 3) + ' ' + str.substr(3, 4) + ' ' + str.substr(7)
      case len > 3:
        return str.substr(0, 3) + ' ' + str.substr(3)
      default:
        return str
    }
  },

  /**
   * 格式化千分符
   * @param {string|number} num
   * @return {string}
   */
  formatThousandMark(num = 0, retain) {
    let format = `${parseFloat((num + '').replace(/[^\d\.-]/g, ''))}`

    if (typeof retain === 'number') {
      format = Number(format).toFixed(retain || 0) + ''
    }

    let [int, float] = format.split('.')

    let targetInt = ''

    while (int.length > 3) {
      targetInt = ',' + int.slice(-3) + targetInt
      int = int.slice(0, int.length - 3)
    }

    if (int) {
      targetInt = int + targetInt
    }

    return float ? `${targetInt}.${float}` : targetInt
  },

  /**
	 * 格式化时间
	 * @params {object|number|string} time
	 * @params {object} fmt format: 'yyyy-MM-dd HH:mm:ss'
	 * @returns {string}
	 */
  formatTime(time, fmt) {
    // const date = this.parseDate(time)
     const date = new Date(time) || new Date()

    let format = fmt || 'yyyy-MM-dd HH:mm:ss'

    const formatOptions = {
      'y': date.getFullYear(), // 年份
      'M': date.getMonth() + 1, // 月份
      'd': date.getDate(), // 日期
      'q': Math.floor((date.getMonth() + 3) / 3), // 季度
      'w': date.getDay(), // 星期，注意是0-6
      'H': date.getHours(), // 24小时制
      'h': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
      'm': date.getMinutes(), // 分钟
      's': date.getSeconds(), // 秒
      'S': date.getMilliseconds() // 毫秒
    }

    const week = ['天', '一', '二', '三', '四', '五', '六']

    for (let i in formatOptions) {
      format = format.replace(new RegExp(i + '+', 'g'), function (m) {
        let val = formatOptions[i] + ''
        if (i == 'w') return (m.length > 2 ? '星期' : '周') + week[val]
        for (let j = 0, len = val.length; j < m.length - len; j++) val = '0' + val
        return m.length == 1 ? val : val.substring(val.length - m.length)
      });
    }

    return format
  },

  parseDate(time) {
    if (validate.isNumberIncludeNumberString(time)) {
      return new Date(Number(time))
    }

    return new Date(time.replace(/-/g, '/'))
  },

  /**
   * 格式化时间
   * @param {number} time
   * @return {string}
   */
  formatTimeHumanize(time) {
    let date = new Date(time)
    let timestamp = Date.now() - date.getTime()

    if (timestamp < TIMESTAMP_UNITS['天']) return humanize(timestamp)

    return date.getFullYear() + '/' + this.parseTens(date.getMonth() + 1) + '/' + this.parseTens(date.getDate()) + '-' + this.parseTens(date.getHours()) + ':' + this.parseTens(date.getMinutes())
  },

  /************************************************** 项目 **************************************************/

  getActivityStatus({ abortDate, startDate, endDate }) {
    const time = new Date().getTime()

    const abortDateTimestamp = new Date(abortDate).getTime()
    const startDateTimestamp = new Date(startDate).getTime()
    const endDateTimestamp = new Date(endDate).getTime()

    // 报名中
    if (time < abortDateTimestamp) return 0
    // 未开始
    if (time >= abortDateTimestamp && time < startDateTimestamp) return 1
    // 进行中
    if (time >= startDateTimestamp && time < endDateTimestamp) return 2
    // 已结束
    if (time > endDateTimestamp) return 3
    return -1
  },

  isExist(data) {
    const _data2Str = Object.prototype.toString
    const isType = (_data, type) => _data2Str.call(_data).slice(8, -1) === type

    return !isType(data, 'Null') && !isType(data, 'Undefined')
  },

  generateUUID() {
  let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (d + Math.random()*16)%16 | 0;
    d = Math.floor(d/16);
    return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  });
  return uuid;
  },

  /**
   * 判断名字是否加姓氏
   * @param surname
   * @param data
   * @returns {*}
   */
  checkName(surname,data){
    if(data === '' || !data){
      return data
    }
    const sl = surname.length
    const dn = data.substr(0,sl)
    if(surname === dn){
      return data.substr(sl,data.length)
    }
    return data
  },
  checkSurnameName(surname,data){
    if(data === '' || !data){
      return data
    }
    const sl = surname.length
    const dn = data.substr(0,sl)
    if(surname === dn){
      return  data
    }
    return surname + data
  }
}
